import { apiClient } from '@/services/base'
import { useMutation, UseMutationResult } from '@tanstack/react-query'

import { IMultiTenantBasicInfoRequest } from './interfaces/request'
import { IMultiTenantBasicInfoResponse } from './interfaces/response'

export const MultiTenantBasicInfoService = async (
  request: IMultiTenantBasicInfoRequest,
): Promise<IMultiTenantBasicInfoResponse> => {
  const response = await apiClient.post(
    'api/Login/MultiTenantBasicInfo',
    request,
  )

  return response?.data
}

export const useMultiTenantBasicInfoService = (): UseMutationResult<
  IMultiTenantBasicInfoResponse,
  Error,
  IMultiTenantBasicInfoRequest
> => {
  return useMutation<
    IMultiTenantBasicInfoResponse,
    Error,
    IMultiTenantBasicInfoRequest
  >({
    mutationFn: async (request) => {
      const response = await MultiTenantBasicInfoService(request)
      return response
    },
  })
}

export type { IMultiTenantBasicInfoRequest, IMultiTenantBasicInfoResponse }
